/* eslint-disable react/prop-types */
import React, { useRef } from 'react';
import {
  Portlet,
  PortletContent,
  PortletHeader,
  PortletLabel,
  PortletToolbar,
} from 'components';
import { Grid2, Skeleton, Typography } from '@mui/material';
import {
  CalendarToday,
  FilterDrama,
  Group,
  TrendingUp,
} from '@mui/icons-material';
import { useIntl } from 'react-intl';
import { Download, ShareButton } from 'components/Download';

export default function DayWithMostConsumeChart({
  title,
  day,
  groupName,
  consume,
  co2,
}) {
  const intl = useIntl();
  const chartRef = useRef();

  return (
    <div style={{ height: '100%' }} ref={chartRef}>
      <Portlet>
        <PortletHeader noDivider={true}>
          {title ? (
            <PortletLabel title={title} />
          ) : (
            <Skeleton variant="text" width={200} height={50} />
          )}
          <PortletToolbar style={{ display: 'flex', gap: 8 }}>
            <Download itemRef={chartRef} name={title} />
            <ShareButton itemRef={chartRef} name={title} />
          </PortletToolbar>
        </PortletHeader>
        <PortletContent style={{ paddingTop: 0 }}>
          <Grid2 container={true} spacing={2}>
            {day ? (
              <Grid2
                item={true}
                size={6}
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
              >
                <CalendarToday sx={{ color: 'black' }} />
                <Typography variant="h6">
                  {intl.formatMessage({
                    id: 'app.group.board.highConsumDayCurrMonth.date',
                  })}
                </Typography>
                <Typography variant="h5" fontWeight="normal">
                  {day ? (
                    day
                  ) : (
                    <Skeleton variant="text" width={100} height={30} />
                  )}
                </Typography>
              </Grid2>
            ) : (
              <Grid2
                item={true}
                size={6}
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
              >
                <Group sx={{ color: 'black' }} />
                <Typography variant="h6">
                  {intl.formatMessage({
                    id: 'app.meter.board.groupHighestConsumMonth.group',
                  })}
                </Typography>
                <Typography variant="h5" fontWeight="normal">
                  {groupName ? (
                    groupName
                  ) : (
                    <Skeleton variant="text" width={100} height={30} />
                  )}
                </Typography>
              </Grid2>
            )}
            <Grid2
              item={true}
              size={6}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <TrendingUp sx={{ color: 'black' }} />
              <Typography variant="h6">
                {intl.formatMessage({
                  id: 'app.group.board.highConsumDayCurrMonth.consumption',
                })}
              </Typography>
              <Typography
                variant="h5"
                fontWeight="normal"
                sx={{ color: '#730065' }}
              >
                {consume ? (
                  consume
                ) : (
                  <Skeleton variant="text" width={100} height={30} />
                )}
              </Typography>
            </Grid2>
            <Grid2
              item={true}
              size={12}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <FilterDrama sx={{ color: 'black' }} />
              <Typography variant="h6">CO2</Typography>
              <Typography
                variant="h5"
                fontWeight="normal"
                sx={{ color: '#ff8024' }}
              >
                {co2 ? (
                  co2
                ) : (
                  <Skeleton variant="text" width={100} height={30} />
                )}
              </Typography>
            </Grid2>
          </Grid2>
        </PortletContent>
      </Portlet>
    </div>
  );
}
